/**
 * Registro dell'"active searcher": l'istanza di FormRicercaMutuo attualmente
 * montata in pagina si registra qui. I tool WebMCP (registrati una sola volta a
 * livello globale) consultano questo registro:
 *   - se c'e` un searcher attivo  -> pilotano il form visibile (UI + dati);
 *   - se non c'e'                  -> fallback via navigazione/query-string.
 *
 * L'adapter espone metodi stabili che internamente leggono gli handler piu`
 * recenti (closure fresca su postData ecc.), vedi useRegisterActiveSearcher.
 */

let active = null;

export const setActiveSearcher = (adapter) => {
  active = adapter;
};

export const clearActiveSearcher = (adapter) => {
  // Pulisce solo se a smontarsi e` davvero l'adapter attivo (evita che lo
  // smontaggio di una vecchia istanza cancelli una piu` recente).
  if (active === adapter) active = null;
};

export const getActiveSearcher = () => active;
